module.exports = __webpack_public_path__ + "static/facebook-logo-b8809a7618ef3e9d0569faa7db3cd5d8.png";